
export const ReportEsitoListInputFilters = (supervisoreOptions: any[]) => ([
    {
        label: 'Data da',
        name: 'DataDa',
        placeholder: 'Data da',
        type: 'text',
        validators: {
            required: 'Il campo è richiesto'
        },
        type_input: 'picker',
        size_input: 'w-full',
        isLimitDate: false,
        isTimeShow: false
    },
    {
        label: 'Data a',
        name: 'DataA',
        placeholder: 'Data a',
        type: 'text',
        validators: {
            required: 'Il campo è richiesto'
        },
        type_input: 'picker',
        size_input: 'w-full',
        isLimitDate: false,
        isTimeShow: false
    },
    {
        label: 'Speaker',
        name: 'IdSpeaker',
        placeholder: 'Speaker',
        type: 'text',
        validators: {},
        type_input: 'react-select',
        size_input: 'w-full',
        options: supervisoreOptions
    },
]);